export default class ButtonMarker {
  public static active(e: HTMLElement, markParent: boolean): void {
    //This is only null if we are using the html tag, which obviously we aren't.
    const parent: HTMLElement = markParent ? e.parentElement! : (e.firstElementChild! as HTMLElement);

    if (parent.classList.contains("active")) return;
    parent.classList.add("active");
  }

  public static notActive(e: HTMLElement, markParent: boolean): void {
    //This is only null if we are using the html tag, which obviously we aren't.
    const parent: HTMLElement = markParent ? e.parentElement! : (e.firstElementChild! as HTMLElement);

    parent.classList.remove("active");
  }

  public static mark(e: HTMLElement, active: boolean): void {
    if (active) {
      ButtonMarker.active(e, true);
    } else {
      ButtonMarker.notActive(e, true);
    }
  }

  public static markChild(e: HTMLElement, active: boolean): void {
    if (active) {
      ButtonMarker.active(e, false);
    } else {
      ButtonMarker.notActive(e, false);
    }
  }

  public static markRadio(e: HTMLElement, checked: boolean): void {
    const firstRadio: HTMLInputElement = e.querySelector("[type=radio]")! as HTMLInputElement;

    firstRadio.checked = checked;
  }
}
